import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "flex items-center w-full ml-auto justify-between gap-x-6 pr-4 font-montserrat" }
const _hoisted_3 = { class: "text-gray-lp-300 font-semibold" }
const _hoisted_4 = { class: "text-red-lp-100 text-sm font-bold" }
const _hoisted_5 = { class: "w-full flex items-stretch text-gray-lp-300 metric-container" }
const _hoisted_6 = { class: "flex flex-row w-1/3" }
const _hoisted_7 = { class: "flex flex-col gap-1 pr-8 flex-1" }
const _hoisted_8 = { class: "text-sm tracking-wide" }
const _hoisted_9 = { class: "text-xl font-semibold text-black-lp-100" }
const _hoisted_10 = { class: "flex flex-row w-1/3" }
const _hoisted_11 = { class: "flex flex-col gap-1 px-8 flex-1 border-l border-gray-lp-1400" }
const _hoisted_12 = { class: "text-sm tracking-wide" }
const _hoisted_13 = { class: "text-xl font-semibold text-black-lp-100" }
const _hoisted_14 = { class: "flex flex-col gap-1 px-8 flex-1 border-l border-gray-lp-1400 w-1/3" }
const _hoisted_15 = { class: "text-sm tracking-wide" }
const _hoisted_16 = { class: "text-xl font-semibold text-black-lp-100" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_AccordionTab = _resolveComponent("AccordionTab")!
  const _component_Accordion = _resolveComponent("Accordion")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Accordion, {
      multiple: "",
      "active-index": [0],
      id: "accordion-weight-summary-stt",
      onTabOpen: _cache[1] || (_cache[1] = ($event: any) => (_ctx.buttonText = String(_ctx.$t('cargo.summary.hide')))),
      onTabClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.buttonText = String(_ctx.$t('cargo.summary.show'))))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AccordionTab, null, {
          header: _withCtx(() => [
            _createVNode("div", _hoisted_2, [
              _createVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("cargo.summary.sttWeightTitle")), 1),
              _createVNode("button", _hoisted_4, _toDisplayString(_ctx.buttonText), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _createVNode("span", _hoisted_8, _toDisplayString(_ctx.$t("cargo.labels.grossWeightStt")), 1),
                  _createVNode("span", _hoisted_9, _toDisplayString(`${_ctx.convertDecimal(_ctx.grossWeight)} kg`), 1)
                ])
              ]),
              _createVNode("div", _hoisted_10, [
                _createVNode("div", _hoisted_11, [
                  _createVNode("span", _hoisted_12, _toDisplayString(_ctx.$t("cargo.labels.volumeWeightStt")), 1),
                  _createVNode("span", _hoisted_13, _toDisplayString(`${_ctx.convertDecimal(_ctx.volumeWeight)} kg`), 1)
                ])
              ]),
              _createVNode("div", _hoisted_14, [
                _createVNode("span", _hoisted_15, _toDisplayString(_ctx.$t("cargo.labels.chargeableWeightStt")), 1),
                _createVNode("span", _hoisted_16, _toDisplayString(`${_ctx.convertDecimal(_ctx.chargeableWeight)} kg`), 1)
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}